import { useState } from 'react';
import { Box, Text, VStack, Button, useToast } from '@chakra-ui/react';
import { CompleteUserBook, UserCreatedBooksService } from '../../../generated/client';
import React from 'react';
import { UserBookServiceFactory } from '../ServiceFactrories/UserBookServiceFactory';
import { UserBookCreationComponent } from './UserBookCreationComponent';

interface Props {
  book: CompleteUserBook;
  userId: string;
  refreshList: () => void;
}

export function UserBookResultsComponent({ book, userId, refreshList }: Props): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userBookServiceFactory: UserCreatedBooksService = UserBookServiceFactory.instance();
  const toast = useToast();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handlePublishUnpublish = async () => {
    const dataToSend: CompleteUserBook = {
      id: book.id,
      comments: book.comments ?? [],
      ratings: book.ratings ?? [],
      isPublic: !book.isPublic,
      title: book.title,
      content: book.content,
      authors: book.authors,
    };
    await userBookServiceFactory.updateBook(book.id, dataToSend);
    await refreshList();
    if (!book.isPublic) {
      toast({
        title: 'Book published successfully',
        status: 'success',
        position: 'top-right',
      });
    } else {
      toast({
        title: 'Book unpublished successfully',
        status: 'success',
        position: 'top-right',
      });
    }
  };

  return (
    <Box>
      <div>
        <hr></hr>
      </div>
      <VStack spacing={5} align='start'>
        <Text fontSize='2xl' fontWeight='bold'>
          {book.title}
        </Text>
        <Text fontSize='md'>
          {book.authors.map((author: { name: unknown }) => author.name).join(', ')}
        </Text>
        <div>
          <Button colorScheme='teal' onClick={openModal} style={{ marginRight: 10 }}>
            Edit
          </Button>
          <Button colorScheme='teal' onClick={handlePublishUnpublish}>
            {book.isPublic ? 'Unpublish' : 'Publish'}
          </Button>
        </div>
        <UserBookCreationComponent
          isCreateNewBookMode={false}
          book={book}
          userId={userId}
          isOpen={isModalOpen}
          closeModal={closeModal}
          refreshList={refreshList}></UserBookCreationComponent>
      </VStack>
    </Box>
  );
}
